import { render, staticRenderFns } from "./KurccForbiddenPage.vue?vue&type=template&id=ffea29fe&scoped=true&"
import script from "./KurccForbiddenPage.vue?vue&type=script&lang=js&"
export * from "./KurccForbiddenPage.vue?vue&type=script&lang=js&"
import style0 from "./KurccForbiddenPage.vue?vue&type=style&index=0&id=ffea29fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea29fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
